import { Allocation } from "./allocation";
import { Identifiable } from "./identifiable";
import { Status } from "./status";
import { Tag } from "./tag";
import { Id } from "./id";
import { Zone } from "./zone";

enum ProjectElementType {
  "PROJECT" = "PROJECT",
  "LIST" = "ACTIVITY",
  "TASK" = "TASK",
  "EVENT" = "EVENT",
  "MILESTONE" = "MILESTONE",
}

type ProjectElementBase = {
  uuid: string;
  activityRootUuid: Id;
  parentUuid: Id;
  parentUuids: Id[];
  name: string;
  description: string;
  startDate: string;
  endDate: string;
  completionDate: string;
  percentComplete: number;
  depth: number;
  keyRank: number;
  createdDate?: string;
  referenceKeyRank: number;
  tags: Tag[];
  attributes: {
    [key: string]: string;
  };
  minStartDate?: string;
  maxEndDate?: string;
  maxStartDate?: string;
  minEndDate?: string;
};

type ProjectElement =
  | (ProjectElementBase & {
      type: ProjectElementType.PROJECT;
      zone: Identifiable<Zone>;
    })
  | (ProjectElementBase & {
      type: ProjectElementType.LIST;
    })
  | (ProjectElementBase & {
      type: ProjectElementType.TASK;
      allocations: Identifiable<Allocation>[];
      status: Identifiable<Status>;
    })
  | (ProjectElementBase & {
      type: ProjectElementType.EVENT;
    })
  | (ProjectElementBase & {
      type: ProjectElementType.MILESTONE;
      state: "DONE" | "TODO";
    });

type OptimizedGantt = ProjectElement[];
const optimizedGantt: OptimizedGantt = [];

export type { OptimizedGantt };

export { ProjectElementType, optimizedGantt };
